import SocialProofComponent from "@/components/organisms/social-proof";

export function ParagraphTestimonials({ paragraph, ...props }) {
  const autoSlide = true;
  const slideInterval = 4500;

  const items = paragraph?.field_ts_testimonials?.map(item => {
    return {
      id: item.id,
      title: item?.field_ti_name ?? '',
      subtitle: item?.field_ti_role ?? '',
      description: item?.field_ti_testimonial ?? '',
      logo: item?.field_ti_image ?? null,
    }
  }) ?? [];

  if (items?.length === 0) return <></>

  return (
    <SocialProofComponent items={items} layout="vertical-contained" isTestimonial={true} autoSlide={autoSlide} slideInterval={slideInterval} />
  )
}